
import { defineComponent, PropType } from 'vue'
import { iTimespan, iInterval } from './Timespan'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import timespanDescriptor from './TimespanDescriptor.json'
import Card from 'primevue/card'
import TimespanIntervalForm from './TimespanIntervalForm.vue'
export default defineComponent({
    name: 'timespan-interval-table',
    props: { propTimespan: { type: Object as PropType<iTimespan | null> } },
    components: { Column, DataTable, Card, TimespanIntervalForm },
    data() {
        return {
            timespanDescriptor,
            timespan: null as iTimespan | null
        }
    },
    watch: {
        propTimespan() {
            this.loadTimespan()
        }
    },
    computed: {
        columns(): { field: string; header: string; style: string }[] {
            return this.timespan?.type === 'temporal' ? this.timespanDescriptor.temporalColumns : this.timespanDescriptor.timeColumns
        }
    },
    created() {
        this.loadTimespan()
    },
    methods: {
        loadTimespan() {
            this.timespan = this.propTimespan as iTimespan
        },
        deleteInterval(interval: iInterval) {
            if (this.timespan) {
                const index = this.timespan.definition.findIndex((tempInterval: iInterval) => interval.from === tempInterval.from && interval.to === tempInterval.to)
                if (index !== -1) this.timespan.definition.splice(index, 1)
            }
        }
    }
})
